import { render } from "./LbrxErrorNotification.vue?vue&type=template&id=0dd4ad9c&scoped=true"
import script from "./LbrxErrorNotification.vue?vue&type=script&lang=js"
export * from "./LbrxErrorNotification.vue?vue&type=script&lang=js"

import "./LbrxErrorNotification.vue?vue&type=style&index=0&id=0dd4ad9c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd4ad9c"]])

export default __exports__